// @flow

import type { GlobalState } from '../types';
import { getAssortmentStore } from './assortment';

export const getFacets = (state: GlobalState) => getAssortmentStore(state).facets;

export const getFacet = (state: GlobalState, label: string) => {
  const facets = getFacets(state);
  return facets[label];
};

export const getMinMaxFromFacet = (state: GlobalState, label: string) => {
  const facet = getFacet(state, label);

  if (!facet) {
    return { min: 0, max: 0 };
  }

  const buckets = Object.entries(facet)
    .reduce((acc, [
      value,
      count,
    ]) => {
      if (count === 0) {
        return acc;
      }
      return [...acc, value];
    }, [])
    .map(bucket => parseInt(bucket, 10))
    .sort((a, b) => a - b);

  return {
    min: buckets[0] || 0,
    max: buckets[buckets.length - 1] || 0,
  };
};

export default null;
